import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { matchBankStatementsWithOrdersAction } from '../../../services/request';
import { Box, Card, CardHeader, CardContent, IconButton, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import { GridToolbar, plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const columns = [
  { field: 'jaro_winkler_total_similarity', headerName: 'Procent dopasowania %', flex: 0.3, valueGetter: params => params.row.jaro_winkler_total_similarity.toFixed(2) },
  { field: 'order_number', headerName: 'Numer zamówienia', flex: 0.3, valueGetter: params => params.row.order.identifier },
  { field: 'guardian', headerName: 'Opiekun', flex: 1, valueGetter: params => params.row.order.guardian_name },
  { field: 'participant', headerName: 'Uczestnik', flex: 1, valueGetter: params => params.row.order.participant_name }
];

const MatchOrder = ({ open, handleClose, orders, transaction, setTransactions }) => {
  const { mutate } = useMutation(matchBankStatementsWithOrdersAction);
  const [selectionModel, setSelectionModel] = React.useState([]);

  const handleMatch = async () => {
    const { error: mutateError, payload } = await mutate({ 'transactions': [transaction], 'order_id': selectionModel[0] });
    if (!mutateError) {
      setTransactions(prev => prev.map(t => {
        if (t.id !== payload.results[0].bank_statement_id) {
          return t;
        }

        if (_.isNil(payload.results[0].best_match)) {
          return { ...t, bestMatch: 'Brak dopasowania' };
        }

        return {
          ...t,
          order_id: payload.results[0].best_match.order.id,
          bestMatch: payload.results[0].best_match.order.identifier,
          guardian: payload.results[0].best_match.order.guardian_name,
          participant: payload.results[0].best_match.order.participant_name
        };
      }));
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '80vw', height: '80vh' }}>
        <CardHeader
          title="Dopasuj transakcje do zamówienia"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent sx={{ height: '80%' }}>
          <DataGridPro
            rows={orders}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            pagination
            checkboxSelection={false}
            components={{ Toolbar: GridToolbar }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
            onSelectionModelChange={newSelection => {
              setSelectionModel(newSelection);
            }}
            selectionModel={selectionModel}
          />
          <Box sx={{ height: '20%' }} display="flex" justifyContent="center" alignItems="center" >
            <Button disabled={selectionModel.length === 0} sx={{ width: '50%' }} variant="contained" onClick={handleMatch}>Dopasuj</Button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default MatchOrder;

